














import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GChatSendButton',
  props: {
    disabled: {
      type: Boolean as PropType<boolean>,
    },
  },
  methods: {
    onClick(): void {
      this.$emit('send');
    },
  },
});
